import React from 'react';
import { Link } from 'react-router-dom';
// import { useSelector } from 'react-redux';
// import { widgetsSelectors } from '../../features/widgets';
import LogoEfeed from "../../icons/logo-efeed.png";

export default function NavBottomBar(props) {
    // const sidebars = useSelector(widgetsSelectors.selectAllWidgets);
    //
    // const getSidebar = (id) => sidebars.find(sb => sb.id === id);
    //
    // const sidebar1 = getSidebar('estore_footer_sidebar1');
    // const sidebar2 = getSidebar('estore_footer_sidebar2');
    // const sidebar3 = getSidebar('estore_footer_sidebar3');
    // const sidebar4 = getSidebar('estore_footer_sidebar4');
    //
    // const linkStyle = { color: 'inherit', textDecoration: 'none' };
    //
    // const renderLinks = (widget) => {
    //     if (!widget || !widget.links) return null;
    //     return widget.links.map((link, idx) => (
    //         <li className='footer-item' key={idx} id={link.id}>
    //             {link.href ? (
    //                 <a href={link.href} style={linkStyle}>{link.text}</a>
    //             ) : (
    //                 link.text
    //             )}
    //         </li>
    //     ));
    // };

    return (
        <footer className='footer'>
            <div className='footer-grid'>

                <div className='footer-column'>
                    <Link to="/">
                        <img src={LogoEfeed} alt="e-Feed" style={{ display: 'block', maxHeight: 40 }} />
                    </Link>
                </div>

                <div className='footer-column'>
                    <div className='footer-title'>КОНТАКТЫ</div>
                    <ul className='footer-list'>
                        <li className='footer-item'>
                            Краснодарский край, город Усть-Лабинск, переулок Точный, строение 2А
                        </li>
                        <li className='footer-item'>
                            <a href="tel:88005508076">8 800 550 80 76</a>
                        </li>
                    </ul>
                </div>

                <div className='footer-column'>
                    <div className='footer-title'>КОМПАНИЯ</div>
                    <ul className='footer-list'>
                        <li className='footer-item'>
                            <Link to="/legal-info">Оферта</Link>
                        </li>
                        <li className='footer-item'>
                            <Link to="/privacy-policy">Политика конфиденциальности</Link>
                        </li>
                        <li className='footer-item'>
                            <Link to="/payment-and-delivery">Оплата и доставка</Link>
                        </li>
                    </ul>
                </div>

                <div className='footer-column'>
                    <div className='footer-title'>УСЛУГИ</div>
                    <ul className='footer-list'>
                        <li className='footer-item'>
                            <Link to="/vet-lab">Ветеринарная лаборатория</Link>
                        </li>
                        <li className='footer-item'>
                            <Link to="/audit-farm">Аудит фермы</Link>
                        </li>
                        <li className='footer-item'>
                            <Link to="/calculation-of-the-ration">Расчет рациона</Link>
                        </li>
                        <li className='footer-item'>
                            <Link to="/feed-lab">Кормовая лаборатория</Link>
                        </li>
                    </ul>
                </div>

                <div className='footer-column'>
                    <div className='footer-title'>ПОМОЩЬ</div>
                    <ul className='footer-list'>
                        <li className='footer-item'>
                            <Link to="/loyalty-program">Программа лояльности</Link>
                        </li>
                    </ul>
                </div>
            </div>
        </footer>
    );
}
